var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"no-underline cursor-pointer transition-all",class:[_vm.themes[_vm.theme], _vm.sizes[_vm.size]],attrs:{"href":_vm.href,"to":_vm.to,"disabled":_vm.disabled,"active-class":"active opacity-100 border-red","exact":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }